import axios from '@/common/axios'

const BASE_URL = '/api/changelog'

export function getChangelogEntries(feed, page) {
  return axios.get(BASE_URL, { params: { feed, page } })
}

export function getChangelogUnread(feed) {
  return axios.get(`${BASE_URL}/unread`, { params: { feed } })
}

export function markChangelogViewed(feed) {
  return axios.post(`${BASE_URL}/mark_viewed`, { feed })
}
